import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const ProductFormStock = ({ formData, setFormData }) => {
  const measurementUnits = ['PCS', 'GRAMS', 'KG', 'LITRE', 'BOX', 'CASE', 'BAG'];
  const unitUpper = (formData.measurement_unit || '').toUpperCase();
  const showBagSize = unitUpper === 'KG' || unitUpper === 'BAG';

  return (
    <>
      <div className="space-y-2">
        <Label>Measurement Unit *</Label>
        <Select value={formData.measurement_unit} onValueChange={(v) => setFormData({ ...formData, measurement_unit: v })}>
          <SelectTrigger data-testid="product-uom-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {measurementUnits.map((u) => <SelectItem key={u} value={u} data-testid={`product-uom-option-${u}`}>{u}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Case Quantity{unitUpper === 'BAG' ? ' (bags per case)' : ''}</Label>
        <Input
          type="number"
          value={formData.case_quantity}
          onChange={(e) => setFormData({ ...formData, case_quantity: e.target.value })}
          data-testid="product-case-quantity-input"
        />
      </div>

      {showBagSize && (
        <div className="space-y-2">
          <Label>{unitUpper === 'BAG' ? 'Bag Size (KG per bag)' : 'Bag Size (KG)'}</Label>
          <Input
            type="number"
            step="0.01"
            min="0"
            placeholder="e.g. 25, 30, 50"
            value={formData.bag_size}
            onChange={(e) => setFormData({ ...formData, bag_size: e.target.value })}
            data-testid="product-bag-size-input"
          />
          <p className="text-[11px] text-slate-400">
            {unitUpper === 'BAG'
              ? 'KG of product inside one bag — used by the OG App for pack display (e.g. "50 kg per bag").'
              : 'Reference only — does not affect inventory or pricing.'}
          </p>
        </div>
      )}

      <div className="space-y-2">
        <Label>Min Stock Level *</Label>
        <Input type="number" value={formData.min_stock_level} onChange={(e) => setFormData({ ...formData, min_stock_level: e.target.value })} required />
      </div>

      <div className="space-y-2">
        <Label>Rack Location</Label>
        <Input value={formData.rack_location} onChange={(e) => setFormData({ ...formData, rack_location: e.target.value })} />
      </div>
    </>
  );
};

export default ProductFormStock;
